export const getDrawerPlacement = () => {
    if (document.documentElement.clientWidth < 768) {
        return "bottom";
    } else {
        return "right";
    }
};
